let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iDoeJ")).then(() => parcelRequire('4YtwO'));